import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

import { LoginComponent } from "./components/login/login.component";
import { RouterModule } from "@angular/router";
import { HashLocationStrategy, LocationStrategy } from "@angular/common";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DialogComponent } from "./components/dialog/dialog.component";

import { DataTablesModule } from "angular-datatables";
import { ChartModule } from "angular2-chartjs";
import { NgChartsModule } from "ng2-charts";
import { LoaderInterceptor } from './loader.interceptor';
import { LoaderComponent } from './components/loader/loader.component';

// import { ChatFeatureComponent } from './components/chat-feature/chat-feature.component';
// import { ChangePasswordComponent } from './components/change-password/change-password.component';
// import { RecoverPasswordComponent } from './components/recover-password/recover-password.component';
// import { ComplaintsViewComponent } from './components/complaints/complaints-view/complaints-view.component';
// import { ComplaintsCreateComponent } from './components/complaints/complaints-create/complaints-create.component';
// import { ComplaintsListComponent } from "./components/complaints/complaints-list/complaints-list.component";
// import { ComplaintsComponent } from './components/complaints/complaints.component'; // Import DataTablesModule
@NgModule({
  declarations: [
    AppComponent,
    DialogComponent,
    LoaderComponent,
    // ChatFeatureComponent,
    // ChangePasswordComponent,
    // RecoverPasswordComponent,
    // ComplaintsViewComponent,
    // ComplaintsCreateComponent,
    // ComplaintsListComponent,
    // ComplaintsComponent,
    // HeaderComponent,
    // SparePartDetailsComponent,
  ],
  exports: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    DataTablesModule,
    ChartModule,
    NgChartsModule,
  ],
  providers: [
    LoginComponent,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
